import React from "react";
import { DiseaseKnowledgeList } from "./DiseaseKnowledgeList";
import { SearchTextField } from "../SearchTextField";

export const DiseaseKnowledgeListDialog = React.memo(function DiseaseKnowledgeListDialog() {
    return (
        <div className={"list_dialog"}>
            <div className={"container"}>
                <h2 className={"title"}>医療知識一覧</h2>
                <SearchTextField />
                <DiseaseKnowledgeList />
            </div>
        </div>
    );
});
